import { render, staticRenderFns } from "./menuAdd.vue?vue&type=template&id=0e6d2a40&scoped=true&"
import script from "./menuAdd.vue?vue&type=script&lang=js&"
export * from "./menuAdd.vue?vue&type=script&lang=js&"
import style0 from "./menuAdd.vue?vue&type=style&index=0&id=0e6d2a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6d2a40",
  null
  
)

export default component.exports